module.exports = __webpack_public_path__ + "media/images/products/retailers-socialmedia-1-hero-b57c66996d6d8e7f74173457e511357e.jpg";